import { atom } from 'jotai';
import type { SchemaGenerationMode } from '@/utils/analytics/types';

/**
 * The id of the Load Data attempt currently in progress, owned by `Ingestion.tsx`.
 *
 * It lives in an atom rather than in props because the wizard's Create New Graph modal sits
 * four levels down inside a shared `GraphSelect`, and only analytics needs the value. Read
 * it only on a surface that is genuinely part of the ingestion flow — it is not cleared when
 * the drawer closes, so an unrelated surface would otherwise inherit a stale attempt id.
 */
export const ingestionFlowIdAtom = atom<string | undefined>(undefined);

/**
 * What the user answered in the Schema Auto Generation modal for the current Load Data
 * attempt, owned by `Ingestion.tsx` (it resets on each opening of the wizard).
 *
 * The modal is offered four levels below the step that ends up creating the loading jobs,
 * and `none` is the correct answer for every attempt that is never offered it — an existing
 * schema, an edited job, a non-CSV source — so the default is a real value, not "unknown".
 */
export const schemaGenerationModeAtom = atom<SchemaGenerationMode>('none');
